import { HomeIcon, AskPriyaIcon, StoriesIcon, MeIcon } from '@/components/NavIcons';

const TABS = [
  { id: 'home',      Icon: HomeIcon,     label: 'Home'      },
  { id: 'ask-priya', Icon: AskPriyaIcon, label: 'Ask Priya' },
  { id: 'stories',   Icon: StoriesIcon,  label: 'Stories'    },
  { id: 'me',        Icon: MeIcon,       label: 'Me'         },
];

export default function BottomNav({ activeTab, onTabChange }) {
  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100%',
      maxWidth: 720,
      background: '#FFFFFF',
      borderTop: '2px dashed #DDDDDD',
      display: 'flex',
      padding: '8px 0 calc(14px + env(safe-area-inset-bottom, 0px))',
      zIndex: 100,
    }}>
      {TABS.map(({ id, Icon, label }) => {
        const active = activeTab === id;
        return (
          <button
            key={id}
            onClick={() => onTabChange(id)}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              minWidth: 64,
              minHeight: 44,
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              color: active ? '#448AFF' : '#999999',
              transition: 'color 0.2s ease',
            }}
          >
            <Icon size={26} strokeWidth={2.5} />
            {active && (
              <div style={{
                width: 4, height: 4, borderRadius: '50%',
                background: '#448AFF', marginTop: 1,
              }} />
            )}
            <span style={{
              fontSize: 11,
              fontWeight: active ? 600 : 400,
              fontFamily: "'Patrick Hand', cursive",
            }}>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
